import React from 'react';
import { ThemeProvider } from 'styled-components';
import theme from './styles/theme';
import GlobalStyle from './styles/GlobalStyle';

import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import AboutUs from './components/AboutUs/AboutUs';
import Services from './components/Services/Services';
import Differentials from './components/Differentials/Differentials';
import Training from './components/Training/Training';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import Testimonials from './components/Testimonials/Testimonials';
import Professionals from './components/Professionals/Professionals';
import Blog from './components/Blog/Blog';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <div id="top" className="App">
        <Header />
        <main>
          <Hero />
          <AboutUs />
          <Services />
          <Differentials />
          <Professionals />
          <Testimonials />
          <Blog />
          <Training />
          <Contact />
        </main>
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default App;
